module.exports = __webpack_public_path__ + "img/to-wallet-filter.b8b7fbcd.png";